<script>

    import { createEventDispatcher } from 'svelte'

    export let provider = 'Estafeta'
    export let service = 'Terrestre'

    const dispatch = createEventDispatcher()

    let services = []

const providers = [
        'Estafeta',
        'Estafeta+',
        'EstafetaLTL',
        'Redpack',
        'FedEx',
        'FedEx+',
        'DHL',
        'Sendex',
        'JTExpress',
        '99Minutos',
        'Paquetexpress',
        'Paquetexpress+',
        'Dliver',
        'BigSmart',
        'TIL',
        'Genka',
    ]

    const servicesList = {
        Estafeta: [
            'Terrestre',
            'Express',
            'Metropolitano',
            '11:30',
            '12:30',
            '2 Dias'
        ],
        'Estafeta+': [
            'Terrestre',
            'Express',
            'Metropolitano',
            '11:30',
            '12:30',
            '2 Dias'
        ],
        EstafetaLTL: [
            'LTL'
        ],
        Redpack: [
            'Ecoexpress',
            'Express',
            'Metropolitano'
        ],
        FedEx: [
            'Express Saver',
            'Standard Overnight'
        ],
        DHL: [
            'EXPRESS DOMESTIC',
            'ECONOMY SELECT DOMESTIC'
        ],
        Sendex: [
            'REGULAR',
            'DIFERIDO',
        ],
        JTExpress: [
            'Terrestre'
        ],
        '99Minutos': [
            'NextDay',
            'CO2',
            'SameDay',
            '99minutos',
        ],
        Paquetexpress: [
            'Terrestre',
            'Express',
            'Superexpress'
        ],
        'Paquetexpress+': [
            'Terrestre'
        ],
        UPS: [
            'UPS Express Saver',
            'UPS Standard'
        ],
        Dliver: [
            'Terrestre'
        ],
        BigSmart: [
            'Next Day'
        ],
        'FedEx+': [
            'Express Saver',
            'Standard Overnight'
        ],
        TIL: [
            'Express',
            'Terrestre'
        ],
        Genka: [
            'STANDARD',
            'EXPRESS',
        ]
    }

    setServices()

    function setServices() {

        services = provider? servicesList[provider] : servicesList.Estafeta

        if(services.indexOf(service) == -1)
            service = services[0]

        dispatch('change')
    }

</script>

<style>
    .select {
        min-width: 100%;
    }

    .select select {
        min-width: 100%;
    }
</style>

<!-- svelte-ignore a11y-no-onchange -->

<div class="columns">
    <div class="column">
        <label for="" class="label">Proveedor</label>
        <div class="field">
            <div class="control">
                <div class="select">
                    <select bind:value={provider} on:change={setServices}>
                        {#each providers as providerItem}
                            <option value="{ providerItem }">{ providerItem }</option>
                        {/each}
                    </select>
                </div>
            </div>
        </div>
    </div>
    <div class="column">
        <label for="" class="label">Servicio</label>
        <div class="field">
            <div class="control">
                <div class="select">
                    <select bind:value={service} on:change={() => dispatch('change')}>
                        {#each services as serviceItem}
                            <option value="{ serviceItem }">{ serviceItem }</option>
                        {/each}
                    </select>
                </div>
            </div>
        </div>
    </div>
</div>